// Configuration centralisée des statuts CRM

export const STATUT_COLORS = {
  prospect: 'bg-gray-100 text-gray-800',
  soumission_cedulee: 'bg-cyan-100 text-cyan-800',
  soum_a_valider: 'bg-pink-100 text-pink-800',
  soum_a_faire: 'bg-indigo-100 text-indigo-800',
  soumission_envoyee: 'bg-blue-100 text-blue-800',
  suivi_a_faire: 'bg-yellow-100 text-yellow-800',
  en_attente: 'bg-lime-100 text-lime-800',
  accepte: 'bg-green-100 text-green-800',
  refuse: 'bg-red-100 text-red-800',
  en_attente_production: 'bg-amber-100 text-amber-800',
  en_production: 'bg-orange-100 text-orange-800',
  finalise: 'bg-purple-100 text-purple-800',
  // 🆕 2026-04-30 — Workflow facturation post-travaux
  envoyer_facture: 'bg-fuchsia-100 text-fuchsia-800',
  attente_paiement: 'bg-rose-100 text-rose-800',
  ferme: 'bg-emerald-100 text-emerald-800',
  // 🆕 2026-05-01 — Inactifs (abandons avant soumission)
  abandonne: 'bg-slate-200 text-slate-700 border-slate-400',

  // Anciens statuts (compatibilité)
  suivi_fait: 'bg-lime-100 text-lime-800',
  depot_effectue: 'bg-cyan-100 text-cyan-800',
  attente_production: 'bg-amber-100 text-amber-800',
  production_terminee: 'bg-purple-100 text-purple-800',
};

export const STATUT_LABELS = {
  prospect: 'Prospect',
  soumission_cedulee: 'Soum. Cédulée',
  soum_a_valider: 'Soum. à valider',
  soum_a_faire: 'Soum. à faire',
  soumission_envoyee: 'Soum. Envoyée',
  suivi_a_faire: 'Suivi à Faire',
  en_attente: 'En Attente',
  accepte: 'Accepté',
  refuse: 'Refusé',
  en_attente_production: 'En Attente de Production',
  en_production: 'En Production',
  finalise: 'Finalisé',
  // 🆕 2026-04-30
  envoyer_facture: 'Envoyer facture',
  attente_paiement: 'Attente paiement',
  ferme: 'Fermé',
  // 🆕 2026-05-01
  abandonne: 'Inactifs',

  // Anciens statuts (compatibilité)
  suivi_fait: 'En Attente',
  depot_effectue: 'Dépôt Effectué',
  attente_production: 'Attente Production',
  production_terminee: 'Production Terminée',
};

// Liste ordonnée pour sélecteurs
export const STATUTS_OPTIONS = [
  { value: 'prospect', label: 'Prospect' },
  { value: 'soumission_cedulee', label: 'Soum. Cédulée' },
  { value: 'soum_a_valider', label: 'Soum. à valider' },
  { value: 'soum_a_faire', label: 'Soum. à faire' },
  { value: 'soumission_envoyee', label: 'Soum. Envoyée' },
  { value: 'suivi_a_faire', label: 'Suivi à Faire' },
  { value: 'en_attente', label: 'En Attente' },
  { value: 'accepte', label: 'Accepté' },
  { value: 'refuse', label: 'Refusé' },
  { value: 'en_attente_production', label: 'En Attente de Production' },
  { value: 'en_production', label: 'En Production' },
  { value: 'finalise', label: 'Finalisé' },
  { value: 'envoyer_facture', label: 'Envoyer facture' },
  { value: 'attente_paiement', label: 'Attente paiement' },
  { value: 'ferme', label: 'Fermé' },
  // 🆕 2026-05-01 — Toujours en dernier (caché par défaut dans le CRM)
  { value: 'abandonne', label: 'Inactifs' },
];

// 🆕 2026-05-01 — Raisons d'abandon (cohérent avec le backend RAISONS_ABANDON)
export const RAISONS_ABANDON = ['Pas répondu', 'Trop cher', 'Concurrence', 'Pas le bon timing', 'Autre'];

// Helper: le statut 'abandonne' est masqué par défaut dans le CRM
export const isStatutMasqueParDefaut = (statut) => statut === 'abandonne';
